import React, { Component } from 'react';

class getItems extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filtro: '' // texto del buscador
    };
  }

  manejarCambio = (e) => {
    this.setState({ filtro: e.target.value.toLowerCase() });
  }

  mostrarItems = () => {
    const { filtro } = this.state;
    const items = this.props.items;

    if (items.length === 0) return null;

    // Filtra los ítems por coincidencia con el filtro
    const itemsFiltrados = items.filter(item =>
      item.item.toLowerCase().includes(filtro)
    );

    return (
      <React.Fragment>
        {itemsFiltrados.map(item => (
          <span key={item.id_item} className="boton_itemv2">
            <button
              className="boton_item_span"
              onClick={() =>
                this.props.recuperar_item(
                  item.id_item,
                  item.item,
                  item.precio_venta,
                  item.iva,
                  item.servicio,
                  item.w_incluido,
                  item.id_rubro,
                  item.id_subrubro,
                  item.pfinal,
                  item.id_combo,
                  item.carga_maxima,
                  item.preferencias
                )
              }
            >
              {item.item}
            </button>
          </span>
        ))}
      </React.Fragment>
    );
  }

  render() {
    const { ok_item } = this.props;
    const { filtro } = this.state;

    return (
      <React.Fragment>
        <div className="mb-2">
          <input
            type="text"
            placeholder="Buscar item..."
            className="form-control"
            value={filtro}
            onChange={this.manejarCambio}
            style={{"width":"100%","height":"30px"}}
          />
        </div>
        <div className="form_items">
          <div class="grid-container_itemv2">
            {ok_item === false ? (
              <div className="div_lbl_loading">
                <img
                  alt="Cargando Imagen . . ."
                  className="lbl_loading"
                  src={require('../images/loading.gif')}
                />
              </div>
            ) : (
              this.mostrarItems()
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default getItems;